import React from 'react'
import FormX from 'sb-formx'
import { useWillMount, useCallback } from 'sb-hooks'
import actions from 'redux/actions'
import { constants } from 'common/helpers'
import { required, email } from 'helpers/validation'

import { Box } from 'components/_new/layout'
import { Button } from 'components/_new/controls'
import EmailField from 'components/_new/auth/EmailField/EmailField'
import PasswordField from 'components/_new/auth/PasswordField/PasswordField'
import ForgotPasswordButton from 'components/auth/ForgotPasswordButton/ForgotPasswordButton'

import messages from './messages'
import s from './FacebookRegisterForm.scss'


const form = new FormX({
  name: 'FacebookRegisterForm',
  fields: {
    email: [ required, email ],
    password: [ required ],
  },
})

const FacebookRegisterForm = ({ email = '', onSubmit }) => {
  useWillMount(() => {
    form.setInitialValues({ email })
  })

  const handleClickForgotBtn = useCallback(() => {
    actions.models.modals.open(constants.modals.RemindPassword)
  }, [])

  const handleSubmit = useCallback(() => {
    form.submit()
      .then((values) => {
        onSubmit(values)
      })
  }, [ onSubmit ])

  return (
    <div>
      <EmailField className={s.fields} field={form.fields.email} standardView />
      <Box mt={16}>
        <PasswordField className={s.fields} field={form.fields.password} standardView autoComplete="new-password" />
      </Box>
      <div className={s.actions}>
        <ForgotPasswordButton onClick={handleClickForgotBtn} />
      </div>
      <Box mt={24}>
        <Button
          id="facebookRegisterForm"
          title={messages.submitBtnTitle}
          weight="normal"
          color="brand"
          size="md"
          fullWidth
          uppercase
          onClick={handleSubmit}
        />
      </Box>
    </div>
  )
}


export default FacebookRegisterForm
